<div class="container-fluid" *ngIf="isLoggedIn">
  <div class="row">
    <div class="col-3 col-md-3 col-lg-3">
      <div class="content-area__white-box">
        <div class="content-area__white-box__heading">
          <h2>{{Instructions}}</h2>
        </div>
        <div style="margin-bottom: 10px;">
          <!-- <span>Select a Kimberly-Clark Professional policy to learn more</span> -->
           <span> {{Message}}</span>
           
        </div>
      </div> 
    </div>
      <div   *ngIf="region == 'NA'" class ="col-9 col-md-9 col-lg-9">
          
              <div class="row justify-content-md-center">
                                               
               <li id="lnkUS" type="button" class="collapsible" (click)="toggleCollapse($event)">
                <i class="fa fa-chevron-down collapsible-logo" *ngIf="!policyPanelExpanded"></i>
                <i class="fa fa-chevron-up collapsible-logo" *ngIf="policyPanelExpanded"></i>
                USA</li>
                <div class="content">
                 
                  <li id="lnkUSOrder" type="button" class="subCollapsible" (click)="toggleCollapse($event)">
                    <i class="fa fa-chevron-down collapsible-logo" *ngIf="!policyOrderExpanded"></i>
                    <i class="fa fa-chevron-up collapsible-logo" *ngIf="policyOrderExpanded"></i>
                    ORDERS</li>
                  <div class="content">
                    <ul>
                        <li class="noBullet" *ngFor="let usOrder of usOrders; let i = index;"> <a href={{usOrder.url}} target="_blank">{{usOrder.name}}</a></li>
                    </ul>
                  </div>
                  <li id="lnkUSChargeback"  type="button" class="subCollapsible" (click)="toggleCollapse($event)">
                    <i class="fa fa-chevron-down collapsible-logo" *ngIf="!policyChargebackExpanded"></i>
                    <i class="fa fa-chevron-up collapsible-logo" *ngIf="policyChargebackExpanded"></i>
                    CHARGEBACK COUPONS</li>
                  <div class="content">
                    <ul>
                      <li class="noBullet" *ngFor="let usCb of usChargebacks; let i = index;"> <a href={{usCb.url}} target="_blank">{{usCb.name}}</a></li>
                    </ul>
                  </div>
                </div>
                    <li id="lnkCanada" type="button" class="collapsible" (click)="toggleCollapse($event)">
                      <i class="fa fa-chevron-down collapsible-logo" *ngIf="!policyCanadaPanelExpanded"></i>
                      <i class="fa fa-chevron-up collapsible-logo" *ngIf="policyCanadaPanelExpanded"></i>
                        CANADA</li>
                <div class="content">
                    <li id="lnkCanadaOrders" type="button" class="subCollapsible"  (click)="toggleCollapse($event)">
                      <i class="fa fa-chevron-down collapsible-logo" *ngIf="!polCanadaOrdersExpanded"></i>
                      <i class="fa fa-chevron-up collapsible-logo" *ngIf="polCanadaOrdersExpanded"></i>
                        ORDERS</li>
                  <div class="content">
                    <ul>
                        <li class="noBullet" *ngFor="let canadaOrder of canadaOrders; let i = index;"> <a href={{canadaOrder.url}} target="_blank">{{canadaOrder.name}}</a></li>
                    </ul>
                  </div>
                     <li id="lnkCanadaChargeback" type="button" class="subCollapsible"  (click)="toggleCollapse($event)">
                      <i class="fa fa-chevron-down collapsible-logo" *ngIf="!polCanadaChargebackExpanded"></i>
                      <i class="fa fa-chevron-up collapsible-logo" *ngIf="polCanadaChargebackExpanded"></i>
                        CHARGEBACK COUPONS</li>
                  <div class="content">
                    <ul>
                    <li class="noBullet" *ngFor="let canadaCb of canadaChargebacks; let i = index;"> <a href={{canadaCb.url}} target="_blank">{{canadaCb.name}}</a></li>
                    </ul>
                  </div>
                </div>

              </div>
          
      </div>

      <div   *ngIf="region == 'LAO'" class ="col-9 col-md-9 col-lg-9">
          
        <div class="row justify-content-md-center">
                                         
         <li id="lnkLAO" type="button" class="collapsible" (click)="toggleCollapse($event)">
          <i class="fa fa-chevron-down collapsible-logo" *ngIf="!policyLAOPanelExpanded"></i>
          <i class="fa fa-chevron-up collapsible-logo" *ngIf="policyLAOPanelExpanded"></i>
          {{defaultCountry}}</li>
          <div class="content">
           
            <li id="lnkLAOCommercial" type="button" *ngIf="defaultCommercialPolicies?.length > 1" class="subCollapsible" (click)="toggleCollapse($event)">
              <i class="fa fa-chevron-down collapsible-logo" *ngIf="!policyCommExpanded"></i>
              <i class="fa fa-chevron-up collapsible-logo" *ngIf="policyCommExpanded"></i>
              <!-- {{ 'policycenter.subHeader.Commercial'|translate }}</li>  -->
               {{ Commercial}}</li>
            <div class="content">
              <ul>
                <li class="noBullet" *ngFor="let defaultComm of defaultCommercialPolicies; let i = index;"> <a href={{defaultComm.url}} target="_blank">{{defaultComm.name}}</a></li>
              </ul>
            </div>
            <li id="lnkLAOOrders" *ngIf="defaultOrdersPolicies?.length > 1"  type="button" class="subCollapsible" (click)="toggleCollapse($event)">
              <i class="fa fa-chevron-down collapsible-logo" *ngIf="!policyOrdersExpanded"></i>
              <i class="fa fa-chevron-up collapsible-logo" *ngIf="policyOrdersExpanded"></i>
              <!-- {{ 'policycenter.subHeader.Orders'|translate }}</li> -->
              {{ Orders }}</li> 
               <div class="content"  *ngIf="defaultOrdersPolicies?.length > 1">
                <ul>
                  <li class="noBullet" *ngFor="let defaultOrder of defaultOrdersPolicies; let i = index;"> <a href={{defaultOrder.url}} target="_blank">{{defaultOrder.name}}</a></li>
                </ul>
              </div>

              <li id="lnkLAOOthers" type="button" *ngIf ="defaultSupportPolicies?.length > 1" class="subCollapsible" (click)="toggleCollapse($event)">
                <i class="fa fa-chevron-down collapsible-logo" *ngIf="!policyOthersExpanded"></i>
                <i class="fa fa-chevron-up collapsible-logo" *ngIf="policyOthersExpanded"></i>
                {{  Others }}</li> 
                 <div class="content">
                  <ul>
                    <li class="noBullet" *ngFor="let defaultOthers of defaultSupportPolicies; let i = index;"> <a href={{defaultOthers.url}} target="_blank">{{defaultOthers.name}}</a></li>
                  </ul>
                </div>
          </div>
               

        </div>
    
</div>

  </div>
</div>
